import { render, staticRenderFns } from "./ContingenciaRegistra.vue?vue&type=template&id=c5d278c0&"
import script from "./ContingenciaRegistra.vue?vue&type=script&lang=js&"
export * from "./ContingenciaRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports